import { Building2, Users, ShieldAlert, Landmark } from 'lucide-react'

export const KYB_CHECKLIST_ICONS: Record<string, typeof Building2> = {
  'registry-lookup': Building2,
  'ownership-ubo': Users,
  'entity-screening': ShieldAlert,
  'trust-analyser': Landmark,
}

export const KYB_CHECKLIST_DESCRIPTIONS: Record<string, string> = {
  'registry-lookup': 'Looks the business up in the official government registry (ASIC/ABR).',
  'ownership-ubo': 'Works out who really owns and controls the business.',
  'entity-screening': 'Screens the business itself against sanctions and adverse media.',
  'trust-analyser': 'Understands trust structures — trustees, beneficiaries and appointors.',
}

export function kybOutcomePlainLabel(outcome: string, legalName: string | null, ownerCount: number): string {
  const name = legalName ?? 'This business'
  const ownerPhrase = ownerCount > 0 ? ` We identified ${ownerCount} owner${ownerCount !== 1 ? 's' : ''}/officer${ownerCount !== 1 ? 's' : ''}.` : ''
  if (outcome === 'PASS') return `${name} passed verification.${ownerPhrase}`
  if (outcome === 'FAIL') return `${name} did not pass verification.${ownerPhrase}`
  if (outcome === 'REFER') return `${name} needs a closer look from your team.${ownerPhrase}`
  return `${name}'s result: ${outcome}`
}
